import { render, staticRenderFns } from "./credits_exhausted_alert.vue?vue&type=template&id=4b0d3185"
import script from "./credits_exhausted_alert.vue?vue&type=script&lang=js"
export * from "./credits_exhausted_alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports